import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "toggle", "chevronCollapsed", "chevronExpanded"]

  connect() {
    this.sync()
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()
    this.panelTarget.hidden = !this.panelTarget.hidden
    this.sync()
  }

  sync() {
    const expanded = !this.panelTarget.hidden
    if (this.hasToggleTarget) {
      this.toggleTarget.setAttribute("aria-expanded", expanded)
    }
    if (this.hasChevronCollapsedTarget) {
      this.chevronCollapsedTarget.hidden = expanded
    }
    if (this.hasChevronExpandedTarget) {
      this.chevronExpandedTarget.hidden = !expanded
    }
  }
}
